import AuthorComponent from './AuthorComponent'
export default AuthorComponent
